<template>
  <Toast />
  <ConfirmDialog group="headless">
    <template #container="{ message, acceptCallback, rejectCallback }">
      <div class="flex flex-col items-center p-8 bg-surface-0 dark:bg-surface-900 rounded">
        <div
          class="rounded-full bg-white outline outline-black inline-flex justify-center items-center h-24 w-24 -mt-20">
          <i class="pi pi-question text-5xl"></i>
        </div>
        <span class="font-bold text-2xl block mb-2 mt-6">{{ message.header }}</span>
        <p class="mb-0">{{ message.message }}</p>
        <div class="flex items-center gap-2 mt-6">
          <Button :label="message.rejectLabel" outlined @click="rejectCallback" class="w-32"></Button>
          <Button :label="message.acceptLabel" @click="acceptCallback" class="w-32"></Button>
        </div>
      </div>
    </template>
  </ConfirmDialog>
  <ModalInboundItemsFormDetail v-if="modalShowInboundItemsFormDetail" @closeModal="closeModal"
    :inboundItemsFormDetail="selectedInboundItemsFormDetail" :parentItemId="$route.params?.id" />
  <ModalChooseProduct v-if="modalShowChooseProduct" @closeModal="closeModalProduct" @submit="submitProduct" />
  <IndexView />
  <div id="overlay" class="fixed inset-0 bg-black bg-opacity-30 z-30" :class="{ hidden: !isBlur }"></div>
  <ViewContainer>
    <section class="p-6">
      <BackButton class="mb-5" to_url="/inbound-items-form" />
      <PageTitle title="Edit Refill Stok" />
      <div
        class="bg-white dark:bg-dark-900 w-full rounded-lg py-6 px-5 shadow-lg shadow-light-100 dark:shadow-dark-500 dark:text-dark-500">
        <InputSelect v-if="currRoleId == 'null'" v-model="inboundItemsForm.outlet_id" id="outlet-id" name="outlet-id" label="Outlet"
        option-label="name" option-value="id"
          :options="allOutlets" placeholder="Pilih Outlet"/>
        <InputRadio v-model="inboundItemsForm.form_type" id="form-type" name="form-type" label="Tipe"
          :options="optionType" :valid="validation.form_type.valid" :error-message="validation.form_type.message" />
        <InputSelect v-if="inboundItemsForm.form_type == 'purchase'" v-model="inboundItemsForm.inbound_from" id="inbound-from" name="inbound-from" label="Asal"
          :options="optionInboundFrom" :valid="validation.inbound_from.valid" :error-message="validation.inbound_from.message" />
        <InputTextCustom v-else v-model="inboundItemsForm.inbound_from" id="inbound-from" name="inbound-from" label="Dari"
          type="text" div_class="w-full" @input="inboundItemsForm.inbound_from = $event.target.value" />
        <InputTextAreaCustom 
          v-model="inboundItemsForm.notes" 
          id="item-note" 
          label="Catatan"
          type="text" 
          div_class="w-full"
          @input="inboundItemsForm.isEdit = true"
        />
        <InputDateTime 
          v-model="inboundItemsForm.createdAt" 
          id="item-note" 
          label="Tanggal"
          type="datetime-local" 
          div_class="w-full"
          @input="inboundItemsForm.isEdit = true"
        />


        <div id="table-header" class="mb-5 mt-5 flex justify-between">
          <AddButton v-if="inboundItemsForm.status != 'paid'" to_url="#" button_text="Pilih Item"
            button_class="text-base py-2 font-medium" @click="showModalProduct" />
        </div>

        <div class="overflow-x-auto">
          <div class="inline-block min-w-full align-middle">
            <div class="overflow-hidden shadow-lg rounded-lg">
              <TableComponent>
                <TableHead>
                  <TableRow>
                    <TableHeadCell>No</TableHeadCell>
                    <TableHeadCell>Action</TableHeadCell>
                    <TableHeadCell>Status</TableHeadCell>
                    <TableHeadCell>Kode Item</TableHeadCell>
                    <TableHeadCell>Nama Item</TableHeadCell>
                    <TableHeadCell>Stok Saat Ini</TableHeadCell>
                    <TableHeadCell>Qty Diterima</TableHeadCell>
                    <TableHeadCell>Catatan</TableHeadCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow v-if="inboundItemsFormDetails?.length == 0">
                    <TableCell colspan="7" customClass="text-center italic text-gray-400 dark:text-dark-500"
                      noTextColor>
                      Belum ada data
                    </TableCell>
                  </TableRow>
                  <TableRow v-else v-for="(inboundItemsFormDetail, index) in inboundItemsFormDetails"
                    :key="inboundItemsFormDetail.id" :index="index" isBody>
                    <TableCell>{{ index + 1 }}</TableCell>
                    <TableCell>
                      <div class="justify-center items-center text-gray-500 dark:text-gray-400 flex" v-if="inboundItemsForm.status != 'paid'">
                        <button v-if="inboundItemsFormDetail.isEdit" :id="'edit-data-' + inboundItemsFormDetail.id"
                          @click="submitInboundItemsFormDetail(inboundItemsFormDetail)"
                          class="border border-gray-400 hover:border-green-700 hover:bg-green-400 flex justify-center items-center mx-1 p-2 rounded-md group">
                          <ArrowDownTrayIcon class="h-4 w-4 group-hover:text-green-700" />
                        </button>
                        <!-- <button :id="'edit-data-' + inboundItemsFormDetail.id"
                          @click="editInboundItemsFormDetail(inboundItemsFormDetail)"
                          class="border border-gray-400 hover:border-green-700 hover:bg-green-400 flex justify-center items-center mx-1 p-2 rounded-md group">
                          <PencilSquareIcon class="h-4 w-4 group-hover:text-green-700" />
                        </button> -->
                        <button :id="'delete-data-' + inboundItemsFormDetail.id"
                          @click="deleteInboundItemsFormDetail(inboundItemsFormDetail)"
                          class="border border-gray-400 hover:border-red-500 hover:bg-red-400 flex justify-center items-center mx-1 p-2 rounded-md group">
                          <TrashIcon class="h-4 w-4 group-hover:text-red-700" />
                        </button>
                      </div>
                    </TableCell>
                    <TableCell>
                      <span :class="{
                        'bg-red-500 dark:bg-red-500 text-light-50 dark:text-white': inboundItemsFormDetail.isEdit,
                        'bg-green-500 dark:bg-green-500 text-white dark:text-white': !inboundItemsFormDetail.isEdit
                      }" class="px-2 py-1 rounded-full text-sm font-medium">
                        {{ inboundItemsFormDetail.isEdit ? 'Belum Disimpan' : 'Tersimpan' }}
                      </span>
                    </TableCell>
                    <TableCell>{{ inboundItemsFormDetail.items?.code }}</TableCell>
                    <TableCell>{{ inboundItemsFormDetail.items?.name }}</TableCell>
                    <TableCell>{{ inboundItemsFormDetail.items?.stockMovements.length > 0 ? inboundItemsFormDetail.items?.stockMovements[0].closing_balance : 0 }}</TableCell>
                    <TableCell>
                      <div v-if="inboundItemsForm.status != 'paid'" class="flex items-center rounded-lg p-1">
                        <button @click="reduceItem(inboundItemsFormDetail)" class="p-1 text-gray-500 hover:text-blue-500 transition-colors">
                          <MinusCircleIcon class="h-5 w-5" />
                        </button>
                        <InputTextCustom v-model="inboundItemsFormDetail.qty" id="item-min-qty-per-unit" type="number" div_class="w-20" min="1" @input="inputQty(inboundItemsFormDetail)"/>
                        <button @click="addItem(inboundItemsFormDetail)" class="p-1 text-gray-500 hover:text-blue-500 transition-colors">
                          <PlusCircleIcon class="h-5 w-5" />
                        </button>
                      </div>
                      <div v-else>
                        {{ inboundItemsFormDetail.qty }}
                      </div>
                    </TableCell>
                    <TableCell>
                      <InputTextAreaCustom 
                        v-model="inboundItemsFormDetail.notes" 
                        id="item-note" 
                        type="text" 
                        div_class="w-full"
                        @input="inboundItemsFormDetail.isEdit = true"
                        rows="1"
                      />
                    </TableCell>
                  </TableRow>
                </TableBody>
              </TableComponent>
            </div>
          </div>
        </div>

        <div class="flex justify-center mt-5 gap-3" v-if="inboundItemsForm.status != 'paid'">
          <Button type="submit" label="Simpan" :loading="loading" @click="submitInboundItemsForm" />
          <Button type="submit" label="Posting" :loading="loading" @click="submitCloseInboundItemsForm" />
        </div>
        <div class="flex justify-center" v-if="inboundItemsForm.status == 'paid'">
          Sudah Diposting
        </div>
      </div>
    </section>
  </ViewContainer>
</template>

<script>
import IndexView from '@/views/IndexView.vue';
import PageTitle from '@/components/PageTitle.vue';
import BackButton from '@/components/buttons/BackButton.vue';
import InputRadio from '@/components/form/InputRadio.vue';
import { mapActions, mapGetters } from 'vuex';
import { Button, ConfirmDialog, Toast } from "primevue";
import AddButton from "@/components/buttons/AddButton.vue";
import {
  TableComponent,
  TableHead,
  TableRow,
  TableHeadCell,
  TableBody,
  TableCell,
} from "@/components/table";
import ModalInboundItemsFormDetail from '@/components/modals/ModalInboundItemsFormDetail.vue';
import { TrashIcon, ArrowDownTrayIcon } from "@heroicons/vue/24/solid";
import ModalChooseProduct from '@/components/modals/ModalChooseProduct.vue';
import ViewContainer from "@/components/ViewContainer.vue";
import InputTextCustom from '@/components/form/InputTextCustom.vue';
import InputTextAreaCustom from '@/components/form/InputTextAreaCustom.vue';
import { PlusCircleIcon, MinusCircleIcon } from "@heroicons/vue/24/solid";
import InputSelect from '@/components/form/InputSelect.vue';
import InputDateTime from '@/components/form/InputDateTime.vue';

export default {
  name: "AddEditCustomer",
  props: ['id'],
  components: {
    IndexView, PageTitle, BackButton,
    InputRadio, Button,
    ConfirmDialog, Toast, AddButton,
    TableComponent, TableHead,
    TableRow, TableHeadCell,
    TableBody, TableCell,
    ModalInboundItemsFormDetail,
    TrashIcon,
    ModalChooseProduct,
    ViewContainer,
    InputTextCustom,
    PlusCircleIcon,
    MinusCircleIcon,
    ArrowDownTrayIcon,
    InputSelect,
    InputTextAreaCustom,
    InputDateTime,
  },
  data() {
    return {
      loading: false,
      currRoleId: localStorage.getItem('role_id'),
      inboundItemsForm: {
        form_type: null,
        inbound_from: null,
        notes: null,
      },
      inboundItemsFormDetails: [],
      validation: {
        form_type: {
          valid: true,
          message: ''
        },
        inbound_from: {
          valid: true,
          message: ''
        },
      },
      validationDetail: {
        item_id: {
          valid: true,
          message: ''
        },
        qty: {
          valid: true,
          message: ''
        },
      },
      field: ['item_id', 'qty'],
      modalShowInboundItemsFormDetail: false,
      isBlur: false,
      selectedInboundItemsFormDetail: null,
      modalShowChooseProduct: false,
    }
  },
  async created() {
    await this.fetchInboundItemsForm();
    await this.fetchInboundItemsFormDetails();
    await this.$store.dispatch('outlets/fetchOutlets');
  },
  computed: {
    ...mapGetters('outlets', ['allOutlets']),
    optionType() {
      return [
        { label: 'Refill Stok', value: 'purchase' },
        { label: 'Lain-lain', value: 'misc' },
      ];
    },
    optionInboundFrom() {
      return [
        { label: 'Pabrik', value: 'pabrik' },
        ...this.allOutlets.map(outlet => ({
          label: outlet.name,
          value: outlet.name
        })),
      ];
    },
  },
  methods: {
    ...mapActions('inbound_items_forms', ['updateInboundItemsForm', 'closeInboundItemsForm']),
    ...mapActions('inbound_items_form_details', ['deleteInboundItemsFormDetailById', 'createInboundItemsFormDetail', 'updateInboundItemsFormDetail']),
    async fetchInboundItemsForm() {
      const response = await this.$store.dispatch('inbound_items_forms/fetchInboundItemsFormById', this.$route.params.id);
      this.inboundItemsForm = response.data;
    },
    async fetchInboundItemsFormDetails() {
      const response = await this.$store.dispatch('inbound_items_form_details/fetchInboundItemsFormDetails', { inbound_items_form_id: this.$route.params.id, limit: 1000 });
      if (response) {
        this.inboundItemsFormDetails = response.data;
      } else {
        this.inboundItemsFormDetails = [];
      }
    },
    addItem(item) {
      const existingItemIndex = this.inboundItemsFormDetails.findIndex(detail => detail.item_id === item.item_id);
      if (existingItemIndex != -1) {
        this.inboundItemsFormDetails[existingItemIndex].qty = Number(this.inboundItemsFormDetails[existingItemIndex].qty) + 1;
        this.inboundItemsFormDetails[existingItemIndex].isEdit = true;
      }
    },
    reduceItem(item) {
      const existingItemIndex = this.inboundItemsFormDetails.findIndex(detail => detail.item_id === item.item_id);
      if (existingItemIndex != -1) {
        this.inboundItemsFormDetails[existingItemIndex].qty = Number(this.inboundItemsFormDetails[existingItemIndex].qty) > 1 ? Number(this.inboundItemsFormDetails[existingItemIndex].qty) - 1 : 1;
        this.inboundItemsFormDetails[existingItemIndex].isEdit = true;
      }
    },
    inputQty(item) {
      item.isEdit = true;
      item.qty = Number(item.qty) <= 0 ? 1 : item.qty;
    },
    submitInboundItemsForm() {
      this.$confirm.require({
        group: 'headless',
        header: 'Apakah anda yakin ingin membuat draft barang masuk?',
        message: 'Silahkan konfirmasi sebelum diproses.',
        acceptLabel: 'Ya',
        rejectLabel: 'Tidak',
        accept: () => {
          this.postInboundItemsForm();
        },
        reject: () => {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Kamu telah membatalkan draft barang masuk', life: 3000 });
        }
      });
    },
    async postInboundItemsForm() {
      try {
        this.loading = true;
        const inboundItemsFormData = {
          form_type: this.formType,
          id: this.$route.params.id,
          notes: this.inboundItemsForm.notes,
          inbound_from: this.inboundItemsForm.inbound_from,
          outlet_id: this.inboundItemsForm.outlet_id,
          createdAt: this.inboundItemsForm.createdAt,
        };

        const isEdit = this.inboundItemsFormDetails.filter(detail => detail.isEdit);

        if (isEdit.length > 0) {
          await this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Ada detail yang diubah. Harap simpan perubahan terlebih dahulu.', life: 3000 });
          return;
        }

        for await (const inboundItemsFormDetail of this.inboundItemsFormDetails) {
          await this.updateInboundItemsFormDetail(inboundItemsFormDetail);
        }

        await this.updateInboundItemsForm(inboundItemsFormData);
        await this.fetchInboundItemsForm();

        await this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Draft Barang Masuk telah dibuat', life: 5000 });
      }
      catch (error) {
        console.error('Failed to save inbound items form:', error);

        if (error.status === 400 && error.response.data.errors) {
          this.validationErrors(error.response.data.errors);
          this.$toast.add({ severity: 'error', summary: 'Failed', detail: error.response.data.message, life: 5000 });
        }
        else {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: error.response.data.message, life: 5000 });
        }
      }
      finally {
        this.loading = false;
      }
    },
    submitCloseInboundItemsForm() {
      this.$confirm.require({
        group: 'headless',
        header: 'Apakah anda yakin ingin posting barang masuk?',
        message: 'Silahkan konfirmasi sebelum diproses.',
        acceptLabel: 'Ya',
        rejectLabel: 'Tidak',
        accept: () => {
          this.postCloseInboundItemsForm();
        },
        reject: () => {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Kamu telah membatalkan posting barang masuk', life: 3000 });
        }
      });
    },
    async postCloseInboundItemsForm() {
      try {
        this.loading = true;
        const inboundItemsFormDataUpdate = {
          form_type: this.formType,
          id: this.$route.params.id,
          notes: this.inboundItemsForm.notes,
          inbound_from: this.inboundItemsForm.inbound_from,
          outlet_id: this.inboundItemsForm.outlet_id,
          createdAt: this.inboundItemsForm.createdAt,
        };

        const inboundItemsFormData = {
          transaction_id: this.$route.params.id,
        };

        const isEdit = this.inboundItemsFormDetails.filter(detail => detail.isEdit);

        if (isEdit.length > 0) {
          await this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Ada detail yang diubah. Harap simpan perubahan terlebih dahulu.', life: 3000 });
          return;
        }

        // for await (const inboundItemsFormDetail of this.inboundItemsFormDetails) {
        //   await this.updateInboundItemsFormDetail(inboundItemsFormDetail);
        // }
        await this.updateInboundItemsForm(inboundItemsFormDataUpdate);
        await this.closeInboundItemsForm(inboundItemsFormData);
        await this.fetchInboundItemsForm();

        await this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Draft Barang Masuk telah dibuat', life: 5000 });
      }
      catch (error) {
        console.error('Failed to save inbound items form:', error);

        if (error.status === 400 && error.response.data.errors) {
          this.validationErrors(error.response.data.errors);
          this.$toast.add({ severity: 'error', summary: 'Failed', detail: error.response.data.message, life: 5000 });
        }
        else {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: error.response.data.message, life: 5000 });
        }
      }
      finally {
        this.loading = false;
      }
    },
    editInboundItemsFormDetail(inboundItemsFormDetail) {
      this.selectedInboundItemsFormDetail = inboundItemsFormDetail;
      this.modalShowInboundItemsFormDetail = true;
      this.isBlur = true;
    },
    async deleteInboundItemsFormDetail(table) {
      this.$confirm.require({
        group: 'headless',
        header: 'Apakah anda yakin ingin menghapus detail?',
        message: 'Silahkan konfirmasi sebelum diproses.',
        acceptLabel: 'Ya',
        rejectLabel: 'Tidak',
        accept: async () => {
          try {
            await this.deleteInboundItemsFormDetailById(table.id);
            this.fetchInboundItemsFormDetails();
            this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Berhasil menghapus detail', life: 3000 });
          }
          catch (error) {
            console.error('Gagal menghapus detail', error);
            this.$toast.add({ severity: 'error', summary: 'Failed', detail: 'Gagal menghapus detail', life: 3000 });
          }
        },
        reject: () => {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Batal menghapus detail', life: 3000 });
        }
      });
    },
    validationErrors(errorMessage) {
      for (let index = 0; index < this.field.length; index++) {
        this.validation[this.field[index]].valid = true;
        this.validation[this.field[index]].message = '';
      }

      errorMessage.forEach((error) => {
        if (this.validation[error.field]) {
          this.validation[error.field].valid = false;
          this.validation[error.field].message = error.message;
        }
      });
    },
    showModal() {
      this.modalShowInboundItemsFormDetail = true;
      this.isBlur = true;
      this.selectedInboundItemsFormDetail = null;
    },
    closeModal() {
      setTimeout(() => {
        this.modalShowInboundItemsFormDetail = false;
        this.isBlur = false;
        this.fetchInboundItemsFormDetails();
      }, 200);
    },
    showModalProduct() {
      this.modalShowChooseProduct = true;
      this.isBlur = true;
    },
    closeModalProduct() {
      setTimeout(() => {
        this.modalShowChooseProduct = false;
        this.isBlur = false;
      }, 200);
    },
    async submitProduct(items) {
      try {
        for await (const item of items) {
          const inboundItemsFormDetailData = {
            inbound_items_form_id: this.$route.params.id,
            item_id: item.id,
          };

          const existingItem = this.inboundItemsFormDetails.find(detail => detail.item_id === item.id);

          if (existingItem) {
            inboundItemsFormDetailData.id = existingItem.id;
            await this.updateInboundItemsFormDetail(inboundItemsFormDetailData);
          }
          else {
            inboundItemsFormDetailData.qty = 0;
            await this.createInboundItemsFormDetail(inboundItemsFormDetailData);
          }
        }

        this.closeModalProduct();
        this.fetchInboundItemsFormDetails();
        this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Item berhasil disimpan', life: 5000 });
      }
      catch (error) {
        console.error('Failed to save item:', error);

        if (error.status === 400 && error.response.data.errors) {
          this.validationErrors(error.response.data.errors);
          this.$toast.add({ severity: 'error', summary: 'Failed', detail: error.response.data.message, life: 5000 });
        }
        else {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: error.response.data.message, life: 5000 });
        }
      }
    },
    submitInboundItemsFormDetail(item) {
      this.$confirm.require({
        group: 'headless',
        header: 'Apakah anda yakin ingin menyimpan item?',
        message: 'Silahkan konfirmasi sebelum diproses.',
        acceptLabel: 'Ya',
        rejectLabel: 'Tidak',
        accept: () => {
          this.postInboundItemsFormDetail(item);
        },
        reject: () => {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Kamu telah membatalkan aksi simpan item', life: 3000 });
        }
      });
    },
    async postInboundItemsFormDetail(item) {
      try {
        const inboundItemsFormDetailData = {
          inbound_items_form_id: this.$route.params.id,
          item_id: item.item_id,
          qty: item.qty,
          notes: item.notes,
        };

        if (item.id) {
          inboundItemsFormDetailData.id = item.id;
          await this.updateInboundItemsFormDetail(inboundItemsFormDetailData);
        }

        // Update the item in the array and set isEdit to false
        this.inboundItemsFormDetails = this.inboundItemsFormDetails.map(detail => {
          if (detail.id === item.id) {
            return { ...item, isEdit: false };
          }
          return detail;
        });
        
        this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Item berhasil disimpan', life: 5000 });
      }
      catch (error) {
        console.error('Failed to save item:', error);

        if (error.status === 400 && error.response.data.errors) {
          this.validationErrorsDetail(error.response.data.errors);
          this.$toast.add({ severity: 'error', summary: 'Failed', detail: error.response.data.message, life: 5000 });
        }
        else {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: error.response.data.message, life: 5000 });
        }
      }
    },
    validationErrorsDetail(errorMessage) {
      for (let index = 0; index < this.field.length; index++) {
        this.validationDetail[this.field[index]].valid = true;
        this.validationDetail[this.field[index]].message = '';
      }

      errorMessage.forEach((error) => {
        if (this.validationDetail[error.field]) {
          this.validationDetail[error.field].valid = false;
          this.validationDetail[error.field].message = error.message;
        }
      });
    }
  },
}
</script>